import React, { useEffect, useState } from "react";
import { Row, Col } from "antd";
import { useDispatch } from "react-redux";

import Container from "../../modules/setting/container";
import GeneralSettingsForm from "../Forms/Settings/General";
import NotificationSettingsForm from "../Forms/Settings/Notification";
import IntegrationSettingsForm from "../Forms/Settings/Integration";
import LanguageSettingsForm from "../Forms/Settings/Language";
import WebhookConfigurationSettingsForm from "../Forms/Settings/WebhookConfiguration";

import "./Settings.scss";
import BrandSettingsForm from "../Forms/Settings/Brand";
import { doGetProfile } from "../../modules/auth/stores/thunk";
import RoutePlanCurrent from "../RoutePlan/RoutePlanCurrent";
import withPage from "./withPage";
import SettingMenu from "../Menu/SettingMenu";
import RoutingEngineSettingsForm from "../Forms/Settings/RoutingEngine";

const SettingsPage = ({
  isFetching,
  setting,
  doGetSetting,
  doUpdateSetting,
  doUpdateBrandSetting,
  currentUser,
  settingType: settingTypeT,
  history,
}) => {
  const dispatch = useDispatch();
  const roles = currentUser?.roles;
  const isPartner = roles?.includes("partner");
  const settingTypeDefault = !isPartner ? "general" : "brand";
  const [settingType, setSettingType] = useState(settingTypeT || settingTypeDefault);

  useEffect(() => {
    doGetSetting();
  }, []);

  const handleOnFinish = async values => {
    await doUpdateSetting(values);
    await dispatch(doGetProfile());
  };

  return (
    <div className="Content SettingsPage">
      <RoutePlanCurrent />
      <div className="ContentMain">
        <Row gutter={16}>
          <Col span={6}>
            <SettingMenu
              history={history}
              setting={setting}
              settingType={settingType}
              setSettingType={setSettingType}
            />
          </Col>
          <Col span={18}>
            <div className="SettingContent">
              {!isPartner && settingType === "general" && (
                <GeneralSettingsForm isFetching={isFetching} setting={setting} handleSubmit={handleOnFinish} />
              )}
              {!isPartner && settingType === "notification" && (
                <NotificationSettingsForm isFetching={isFetching} setting={setting} handleSubmit={handleOnFinish} />
              )}
              {!isPartner && settingType === "integration" && (
                <IntegrationSettingsForm isFetching={isFetching} setting={setting} handleSubmit={handleOnFinish} />
              )}
              {!isPartner && settingType === "webhook-configuration" && (
                <WebhookConfigurationSettingsForm
                  isFetching={isFetching}
                  setting={setting}
                  handleSubmit={handleOnFinish}
                />
              )}
              {settingType === "language" && (
                <LanguageSettingsForm isFetching={isFetching} setting={setting} handleSubmit={handleOnFinish} />
              )}
              {settingType === "brand" && (
                <BrandSettingsForm doUpdateBrandSetting={doUpdateBrandSetting} setting={setting} />
              )}
              {settingType === "routing-engine" && (
                <RoutingEngineSettingsForm isFetching={isFetching} setting={setting} handleSubmit={handleOnFinish} />
              )}
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default withPage(Container(SettingsPage));
